// Lightweight GA4 / ads conversion tracking helper.
// Safe to call at any time — silently no-ops if gtag isn't loaded.

export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (_) {
    // swallow
  }
};

// Named helpers so call sites read cleanly.
export const track = {
  calcStarted: (payload) => trackEvent("calc_started", { ...payload, location: "thuisbatterij_landing" }),
  calcCompleted: (payload) => trackEvent("calc_completed", { ...payload, location: "thuisbatterij_landing" }),
  leadSubmitted: (payload) => trackEvent("generate_lead", { ...payload, location: "thuisbatterij_landing" }),
  phoneClick: () => trackEvent("phone_click", { location: "thuisbatterij_landing" }),
  whatsappClick: () => trackEvent("whatsapp_click", { location: "thuisbatterij_landing" }),
  ctaClick: (label) => trackEvent("cta_click", { label, location: "thuisbatterij_landing" }),
};
